// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Refunds from '../refunds/Refunds';
import {actions} from '../duck';
import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    refunds: state.legalConfig.refunds,
    isSaving: state.legalConfig.isSaving,
    isFetchingRefunds: state.legalConfig.isFetchingRefunds,
    saveRefundsError: state.legalConfig.saveRefundsError,
    saveRefundsSuccess: state.legalConfig.saveRefundsSuccess,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...actions}, dispatch)
)(Refunds);
